import { EVENTS } from '../events';

/**
 * Chat alert notification plugin
 *
 * You can customize chat ringtone using chat settings like below
 *
 * `options: {
 *      ...
 *      alert: {
 *        url: 'https://domain.tdl/path/to/tone',
 *        enable: true
 *      }
 *  }`
 */
export class ChatNotificationAlertPlugin {

	constructor(chat){
		this.chat = chat;
        this.url ='https://dobrian.github.io/cmp/topics/sample-recording-and-playback-with-web-audio-api/freejazz.wav';

        this.unread_count = 0;
        this.enable = true;
	}

	init() {
        if (this.chat.options.alert && this.chat.options.alert.url) {
            this.url = this.chat.options.alert.url;
        }

        if (this.chat.options.alert && this.chat.options.alert.enable) {
            this.enable = this.chat.options.alert.enable;
        }

        jQuery(window).click(() => {
            this.setup_player();
        });

		const picker = jQuery(BTN_TEMPLATE);

		if (this.chat.options.is_admin) {
			this.chat.$el.find('.chat-panel-header .search-box-toggle').before(picker);
		} else {
			this.chat.$el.find('.chat-panel-header .wschat-chat-toggle').before(picker);
		}

		picker.click(() => this.toggle());

		this.chat.on(EVENTS.WSCHAT_ON_PONG, data => this.on_pong(data));
		this.chat.on(EVENTS.WSCHAT_ON_READ_ALL_MESSAGE, () => this.reset_unread_count());
		this.chat.on(EVENTS.WSCHAT_ON_SET_CONVERSATION, () => this.reset_unread_count());
		this.chat.on(EVENTS.WSCHAT_PLAY_NOTIFICATION_TONE, () => this.play());
	}

	setup_player() {
	    if (this.player) {
	        return;
	    }

        this.player = new Audio(this.url);
        this.player.volume = 0.5;

        this.update_ui();
	}

	reset_unread_count() {
	    this.unread_count = this.chat.conversation.unread_count;
	}

	on_pong(data) {

	    if (!data.unread_count || !this.player || this.player.error || this.unread_count == data.unread_count) {
	        return false;
	    }

	    console.log({'this': this.unread_count, 'data': data.unread_count});

	    this.unread_count = data.unread_count;

	    this.play();
	}

	update_ui() {
		const icon = this.chat.$el.find('#wschat_alert_toggle i');

		if (this.enable) {
			icon.text('volume_up');
		} else {
			icon.text('volume_off');
		}
	}

	toggle() {
		this.enable = !this.enable;

		this.update_ui();
	}

	enabled() {
		return this.enable;
	}

	play() {
	    this.enable && this.player && this.player.play();
	}
}

export const BTN_TEMPLATE = `
	<button id="wschat_alert_toggle" class="btn btn-outline-primary border-0 text-white" title="Toggle Alert">
		<i class="material-icons">volume_up</i>
	</button>
`;
